import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, TypographyStyledGlobal, fontWeight } from '../../../theme';
import AllVerbatimModal from '../../Modals/DashboardModal/allVerbatimModal';
import { ClauseFilterLabelProps } from '../dashboardInterfaces';
import { ButtonDiv, ConversationButtonStyled, QuoteVerbatimStyled, TextVerbatimStyled, VerbatimContainerStyled, AllVerbatimContainerStyled } from '../styled';
import { ReactComponent as VerbatimImage } from '../../../assets/charts/global-verbatim.svg';
import { ReactComponent as VerbatimQuote } from '../../../assets/verbatim/quote.svg';

type GlobalVerbatimIndicatorProps = {
    question: any,
    verbatims: any,
    selectedClauseFilterLabel?: Array<ClauseFilterLabelProps>
}

const GlobalVerbatimIndicator: FC<GlobalVerbatimIndicatorProps> = ({ question, verbatims, selectedClauseFilterLabel }) => {
    const [openModal, setOpenModal] = useState(false);
    const displayedVerbatims = verbatims ? verbatims.datas.slice(0, 5) : [];
    const { t } = useTranslation('dashboard');

    return (
        <>
            <AllVerbatimContainerStyled>
                {displayedVerbatims.map((verbatim: any) => (
                    <VerbatimContainerStyled key={verbatim.interviewId}>
                        <QuoteVerbatimStyled>
                            <VerbatimQuote />
                        </QuoteVerbatimStyled>
                        <TextVerbatimStyled>
                            {verbatim.openData}
                        </TextVerbatimStyled>
                    </VerbatimContainerStyled>

                ))}
            </AllVerbatimContainerStyled>
            { displayedVerbatims.length > 0 && (
                <ButtonDiv>
                    <ConversationButtonStyled bgColor='white' bgColorHover={colors.grey1400} boxShadow={false} fontColor={colors.grey100} margin='0px 0px 0px 15px' onClick={() => setOpenModal(true)} marginLeft>
                        <VerbatimImage height={35} width={35} />
                        <TypographyStyledGlobal
                            margin='0px'
                            weight={fontWeight.regular}
                        >
                            {t('addIndicatorModal.addGlobalVerbatimIndicator.displayAllVerbatimTitle')}
                        </TypographyStyledGlobal>
                    </ConversationButtonStyled>
                </ButtonDiv>
            )}
            <AllVerbatimModal openModal={openModal} questionLabel={question.label} selectedClauseFilterLabel={selectedClauseFilterLabel} setOpenModal={setOpenModal} verbatims={verbatims} />
        </>
    );
};

export default GlobalVerbatimIndicator;
